import React from 'react'

const Social = () => {
    return (
        <ul id="social">
        <li>
        <a href="https://github.com/inblack67" target="_blank" rel='noopener noreferrer'>
        <i className="fab fa-github fa-2x red-text left"></i>
        </a>

        </li>
      
        <li>
        <a href="https://www.linkedin.com/in/aman-bhardwaj-954a6215a" target="_blank" rel='noopener noreferrer'>
        <i className="fab fa-linkedin fa-2x red-text left"></i>
        </a>
        </li>

        <li className='hide-on-small'>
        <a href="https://www.npmjs.com/~inblack67" target="_blank" rel='noopener noreferrer'>
        <i className="fab fa-npm fa-2x red-text left"></i>
        </a>
        </li>

        <li>
        <a href="https://medium.com/@inblack67" target="_blank" rel='noopener noreferrer'>
        <i className="fab fa-medium fa-2x red-text left"></i>
        </a>
        </li>
      
        <li className='hide-on-small'>
        <a href="https://www.hackerrank.com/amanbhardwaj_041?hr_r=1" target="_blank" rel='noopener noreferrer'>
        <i className="fab fa-hackerrank fa-2x red-text left hide-on-small"></i>
        </a>
        </li>
      
        <li>
        <a href="https://codepen.io/inblack67" target="_blank" rel='noopener noreferrer'>
        <i className="fab fa-codepen fa-2x red-text left"></i>
        </a>
        </li>
    
      
        <li>
        <a href='mailto:amanbhardwaj.04091997@gmail.com' rel='noopener noreferrer'>
        <i className="fa fa-envelope fa-2x red-text left"></i>
        </a>
        </li>
        </ul>
    )
}

export default Social
